import Service from '../../utils/request';
const api = {
    /**
        * 获取机场树形列表
        * @param {*} params 
        * @returns 
    */
    getDockTree: (params) => Service.get('/fcs/dock/tree', params),
    /**
     * 获取站点列表
     * @param {*} params 
     */
     fetchSiteList: (params) => Service.get('/fcs/site/list', params),
}

export default api;